import React from "react";
import { useLocation } from "react-router-dom";
import navMenu from "../../../../../general/constants/navMenu";
import ItemNavMenuModule from "./modules/ItemNavMenu.module";
import COMMON_FIELDS from "../../../../../general/constants/commonFields";
import * as ST from "./styled";
import { authActions } from "../../../../../business.InterfaceLayer/store/entities/auth.entity/redux/slice";
import { useAppDispatch } from "../../../../../business.InterfaceLayer/store/services/hooks.service/redux.hook";
import { ReactComponent as ExitIcon } from "../../../../../general/constants/icons/exit.svg";
import AuthStore from "src/old/Store/AuthStore";

const NavMenuModule = () => {
	const location = useLocation();
	const dispatch = useAppDispatch();

	return (
		<ST.NavMenuModule>
			{navMenu.map((item, index) => {
				const isSelected =
					[location.pathname, `${location.pathname}/`].includes(item.key) ||
					item.activeNav.some((e) =>
						[location.pathname, `${location.pathname}/`].includes(e)
					);
				return (
					<ItemNavMenuModule
						key={`navItem-${item.key}-index${index}`}
						{...{
							[COMMON_FIELDS.LINK]: item[COMMON_FIELDS.KEY],
							[COMMON_FIELDS.IS_ACTIVE]: isSelected,
							[COMMON_FIELDS.LABEL]: item[COMMON_FIELDS.LABEL],
							[COMMON_FIELDS.ICON]: item[COMMON_FIELDS.ICON],
						}}
					/>
				);
			})}
			<ST.LineStrix />
			<ItemNavMenuModule
				{...{
					[COMMON_FIELDS.LINK]: "",
					[COMMON_FIELDS.ON_CLICK]: (e) => {
						e.preventDefault();
						e.stopPropagation();
						AuthStore.logout();
						dispatch(authActions.logout());
					},
					[COMMON_FIELDS.IS_ACTIVE]: false,
					[COMMON_FIELDS.LABEL]: "Выход",
					[COMMON_FIELDS.ICON]: ExitIcon,
				}}
			/>
		</ST.NavMenuModule>
	);
};

export default React.memo(NavMenuModule);
